/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyConfig } from '../models/CompanyConfig';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyConfigService {

    /**
     * Get company config
     * @returns CompanyConfig Success
     * @throws ApiError
     */
    public static getCompanyConfig(): CancelablePromise<CompanyConfig> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/config',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
